<template>
  <div class="window">
    <h1 class="mb-9">免费注册</h1>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <form>
        <ValidationProvider v-slot="{ errors }" name="账号" rules="required">
          <v-text-field
            label="请输入您的账号"
            v-model="username"
            :error-messages="errors"
            clearable
            required
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="密码"
          vid="password"
          rules="required|password:@password2"
        >
          <v-text-field
            label="请输入您的密码"
            v-model="password"
            :error-messages="errors"
            clearable
            required
            :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passwordShow ? 'text' : 'password'"
            @click:append="passwordShow = !passwordShow"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="密码"
          vid="password2"
          rules="required|password:@password"
        >
          <v-text-field
            label="请再次输入您的密码"
            v-model="password2"
            :error-messages="errors"
            clearable
            required
            :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passwordShow ? 'text' : 'password'"
            @click:append="passwordShow = !passwordShow"
          />
        </ValidationProvider>
        <ValidationProvider v-slot="{ errors }" name="QQ号码" rules="required">
          <v-text-field
            label="请再次输入您的QQ号码"
            v-model="qq"
            :error-messages="errors"
            clearable
            required
          />
        </ValidationProvider>
        <ValidationProvider v-slot="{ errors }" name="手机号" rules="required">
          <v-text-field
            label="请输入您的手机号码"
            v-model="tel"
            :error-messages="errors"
            clearable
            required
            ref="tel"
          />
        </ValidationProvider>
        <ValidationProvider v-slot="{ errors }" name="验证码" rules="required">
          <v-text-field
            label="请输入您的验证码"
            v-model="smscode"
            :error-messages="errors"
            clearable
            required
          >
            <v-btn
              slot="append"
              class="primary--text"
              text
              @click.stop="captcha"
              v-if="captchaRestTime === 0"
              :loading="captchaLoading"
              :disabled="captchaLoading"
              >获取验证码</v-btn
            >
            <v-btn slot="append" class="primary--text" text v-else
              >{{ captchaRestTime }}秒后重试</v-btn
            >
          </v-text-field>
        </ValidationProvider>
        <v-btn
          class="mt-7"
          @click="submit"
          color="primary"
          :loading="loading"
          :disabled="loading || invalid"
          block
          rounded
          >注册</v-btn
        >
        <ValidationProvider v-slot="{ errors }" name="服务协议" rules="fwxy">
          <div class="d-flex justify-space-between align-center mt-5">
            <v-checkbox v-model="checkbox" :error-messages="errors" required>
              <template v-slot:label>
                <a
                  href="http://www.yunucms.com/article/show/id/15.html"
                  target="_blank"
                  @click.stop
                  >阅读并接受《服务协议》</a
                >
              </template>
            </v-checkbox>
            <v-btn class="primary--text" text @click="link('/')"
              >返回登录</v-btn
            >
          </div>
        </ValidationProvider>
      </form>
    </ValidationObserver>
    <Message ref="message" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import '@/static/gt.js'

import Message from '@/components/Message.vue'

extend('required', {
  ...required,
  message: '{_field_} 不能为空',
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: '{_field_} 不一致',
})

extend('fwxy', {
  validate(value) {
    return value
  },
  message: '阅读并接受《服务协议》',
})

export default Vue.extend({
  name: 'Register',
  components: {
    ValidationProvider,
    ValidationObserver,
    Message,
  },
  data: () => ({
    loading: false,
    username: '',
    password: '',
    password2: '',
    qq: '',
    tel: '',
    smscode: '',
    checkbox: false,
    captchaRestTime: 0,
    captchaLoading: false,
    passwordShow: false,
  }),
  computed: mapState(['domain']),
  methods: {
    link(name) {
      this.$router.push(name)
    },
    captcha() {
      if (this.tel === '') {
        this.$refs.message.show({
          text: '手机号不能为空',
          color: 'error',
        })
        this.$refs.tel.focus()
        return
      }
      this.captchaLoading = true
      this.$http({
        method: 'GET',
        url: '/Sms/getVerify/t/' + new Date().getTime(),
      }).then(({ data: res }) => {
        window.initGeetest(
          {
            gt: res.gt,
            challenge: res.challenge,
            new_captcha: res.new_captcha,
            product: 'bind',
            offline: !res.success,
          },
          (captchaObj) => {
            captchaObj
              .onReady(() => {
                this.captchaLoading = false
                captchaObj.verify()
              })
              .onSuccess(() => {
                var validate = captchaObj.getValidate()
                this.captchaRestTime = 60
                let timer = setInterval(() => {
                  if (this.captchaRestTime <= 0) {
                    clearInterval(timer)
                    return
                  }
                  this.captchaRestTime--
                }, 1000)
                this.$http({
                  method: 'POST',
                  url: '/Sms/index.html',
                  data: {
                    tel: this.tel,
                    geetest_challenge: validate.geetest_challenge,
                    geetest_validate: validate.geetest_validate,
                    geetest_seccode: validate.geetest_seccode,
                  },
                }).then(({ data: res }) => {
                  if (res.code != 0) {
                    this.captchaRestTime = 0
                    this.$refs.message.show({
                      text: res.msg,
                      color: 'error',
                    })
                  }
                })
              })
          }
        )
      })
    },
    submit() {
      this.loading = true
      this.$http({
        method: 'POST',
        url: '/Login/register.html',
        data: {
          username: this.username,
          password: this.password,
          qq: this.qq,
          tel: this.tel,
          smscode: this.smscode,
        },
      }).then(({ data: res }) => {
        this.loading = false
        if (res.state === 1) {
          this.$refs.message.show(
            {
              text: '注册成功',
              color: 'success',
              timeout: 1000,
            },
            () => {
              window.location.href = this.domain + '/User/Index/index.html'
            }
          )
        } else {
          this.$refs.message.show({
            text: res.mess,
            color: 'error',
          })
        }
      })
    },
  },
})
</script>

<style scoped lang="scss"></style>
